import { render } from "./blog-more-luxury.vue?vue&type=template&id=6c24054c&scoped=true"
import script from "./blog-more-luxury.vue?vue&type=script&lang=js"
export * from "./blog-more-luxury.vue?vue&type=script&lang=js"

import "./blog-more-luxury.vue?vue&type=style&index=0&id=6c24054c&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c24054c"]])

export default __exports__